import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportMatchingContainerComponent } from './components/import-matching-container/import-matching-container.component';
import { ImportMatchingRoutingModule } from './import-matching-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatchingModule } from '../matching/matching.module';

@NgModule({
  declarations: [
      ImportMatchingContainerComponent,
    ],
    imports: [
      CommonModule,
      ImportMatchingRoutingModule,
      SharedModule,
      MatchingModule
    ],
})
export class ImportMatchingModule { }
